import { render, staticRenderFns } from "./AddMapping.vue?vue&type=template&id=53b9f43c&scoped=true"
import script from "./AddMapping.vue?vue&type=script&lang=js"
export * from "./AddMapping.vue?vue&type=script&lang=js"
import style0 from "./AddMapping.vue?vue&type=style&index=0&id=53b9f43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b9f43c",
  null
  
)

export default component.exports